import { updateObject } from "../../helpers/utility.helper";
import IRealtimeViewState from "../models/IRealtimeViewState";
import { initialState } from "../state/realtimeViewSensorData.state";
import iaqRealtimeViewDataType from "../types/iaqRealtimeView.type";

const getRealtiveViewDataStart = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    realtimeViewData: updateObject(oldState.realtimeViewData, {
      error: null,
      loading: true,
      success: false,
    }),
  });
};

const getRealtiveViewDataSuccess = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    realtimeViewData: updateObject(oldState.realtimeViewData, {
      data: action.payload,
      error: null,
      success: true,
      loading: false,
    }),
  });
};

const getRealtiveViewDataError = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    realtimeViewData: updateObject(oldState.realtimeViewData, {
      error: action.payload,
      success: false,
      loading: false,
    }),
  });
};

const resetRealtiveViewData = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    realtimeViewData: updateObject(oldState.realtimeViewData, {
      data: initialState.realtimeViewData.data,
      error: null,
      success: true,
      loading: false,
    }),
  });
};

const getIAQThresholdStart = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    IIAQSensorThresholdState: updateObject(oldState.IIAQSensorThresholdState, {
      error: null,
      isLoading: true,
    }),
  });
};

const getIAQThresholdSuccess = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    IIAQSensorThresholdState: updateObject(oldState.IIAQSensorThresholdState, {
      data: action.payload,
      isLoading: false,
      success: true,
    }),
  });
};

const getIAQThresholdError = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    IIAQSensorThresholdState: updateObject(oldState.IIAQSensorThresholdState, {
      error: action.payload,
      isLoading: false,
      success: false,
    }),
  });
};

const resetIAQThreshold = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    IIAQSensorThresholdState: updateObject(oldState.IIAQSensorThresholdState, {
      ...initialState.IIAQSensorThresholdState.data,
    }),
  });
};



const iaqRealtimeViewDataReducer = (
  oldState: IRealtimeViewState = initialState,
  action: any,
) => {
  switch (action.type) {
    case iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_DATA_START:
      return getRealtiveViewDataStart(oldState, action);
    case iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_DATA_SUCCESS:
      return getRealtiveViewDataSuccess(oldState, action);
    case iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_DATA_ERROR:
      return getRealtiveViewDataError(oldState, action);
    case iaqRealtimeViewDataType.RESET_IAQ_REALTIME_VIEW_DATA:
      return resetRealtiveViewData(oldState, action);
    case iaqRealtimeViewDataType.GET_IAQ_THRESHOLD_BY_ICCID_START:
      return getIAQThresholdStart(oldState, action)
    case iaqRealtimeViewDataType.GET_IAQ_THRESHOLD_BY_ICCID_ERROR:
      return getIAQThresholdError(oldState, action)
    case iaqRealtimeViewDataType.GET_IAQ_THRESHOLD_BY_ICCID_SUCCESS:
      return getIAQThresholdSuccess(oldState, action)
    case iaqRealtimeViewDataType.RESET_IAQ_THRESHOLD_STATE:
      return resetIAQThreshold(oldState, action)
    default:
      return oldState;
  }
};
export default iaqRealtimeViewDataReducer;
